import 'polyfill';
import React from 'react';
import { Provider } from 'react-redux';
import store, { history } from 'store/storeConfig';
import ConnectedApp from './ConnectedApp';

const App = () => {
  return (
    <Provider store={store}>
      <ConnectedApp history={history} />
    </Provider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/containers/app/index.js